import { RouteRecordRaw } from "vue-router";

export const courseTypeRoutes: Array<RouteRecordRaw> = [
  {
    path: "/course-types/:id/edit",
    name: "CourseTypeEdit",
    component: () => import("../views/CourseTypeEdit.vue"),
    meta: {
      requiresAuth: true,
      requiredModule: "courseType",
      requiredRight: "viewUI",
    },
  },
];
